import React, { useState, useEffect } from 'react';
import { buildsAPI } from '../api';

function APKBuilds() {
  const [builds, setBuilds] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBuilds();
  }, []);

  const loadBuilds = async () => {
    setLoading(true);
    try {
      const [buildsRes, statsRes] = await Promise.all([
        buildsAPI.list(),
        buildsAPI.getStats(),
      ]);
      setBuilds(buildsRes.data.builds);
      setStats(statsRes.data.stats);
    } catch (error) {
      console.error('Error loading builds:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading builds...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="mb-3">Builds</h1>

      {stats && stats.total_builds > 0 && (
        <div className="card mb-3">
          <h3 className="mb-2">Build Statistics</h3>
          <div className="d-flex gap-3">
            <div>
              <p className="text-muted text-small">Total Builds</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{stats.total_builds}</p>
            </div>
            <div>
              <p className="text-muted text-small">Total Size</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>
                {formatBytes(stats.total_size)}
              </p>
            </div>
            <div>
              <p className="text-muted text-small">Versions</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{stats.versions.length}</p>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <h3 className="mb-2">Available Builds ({builds.length})</h3>
        {builds.length === 0 ? (
          <p className="text-muted">No builds available.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Filename</th>
                <th>Version</th>
                <th>Size</th>
                <th>Build Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {builds.map((build, index) => (
                <tr key={index}>
                  <td>{build.filename}</td>
                  <td>
                    <span className="badge badge-info">{build.version}</span>
                  </td>
                  <td>{formatBytes(build.sizeBytes)}</td>
                  <td>{formatDate(build.buildDate)}</td>
                  <td>
                    <a
                      href={buildsAPI.download(build.filename)}
                      className="btn btn-primary"
                      style={{ padding: '6px 12px', fontSize: '12px' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default APKBuilds;
